export type CustomerAndUserIds = {
  customerId: number;
  userId: number;
};

export enum INTERNAL_CUSTOMER {
  COVIDEO = '3',
  AUTOMOTIVE = '50303',
  DEV = '54188',
}
